import { render, staticRenderFns } from "./ManageDatabaseSystems.vue?vue&type=template&id=07767b88&"
import script from "./ManageDatabaseSystems.js?vue&type=script&lang=js&"
export * from "./ManageDatabaseSystems.js?vue&type=script&lang=js&"
import style0 from "./ManageDatabaseSystems.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
